import Hero from "@components/PageComponents/Accueil/Hero";
import AccueilNews from "@components/PageComponents/Accueil/News";
import AmbitionsPro from "@components/PageComponents/Accueil/AmbitionsPro";
import SEO from "@components/SEO";
import Resultats from "@components/PageComponents/Accueil/Resultats";

import React from "react";
import { contentSlideUp, parent, transition } from "@services/motionTransitions";
import { motion } from "framer-motion";
import MatchsAVenir from "@components/PageComponents/Accueil/FuturMatchs";
import { NextPage } from "next";
import HOF from "@components/PageComponents/Accueil/HOF";
// import { useTranslation } from "next-i18next";
// import { serverSideTranslations } from "next-i18next/serverSideTranslations";

//Module multi-lang
// export async function getStaticProps({ locale }) {
//   return {
//     props: {
//       ...(await serverSideTranslations(locale, [
//         "common",
//         "home",
//         "navbar",
//         "footer",
//       ])),
//       // Will be passed to the page component as props
//     },
//   };
// }

export async function getStaticProps() {
  const client = require("contentful").createClient({
    space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
    accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  });

  const articles = await client.getEntries({ content_type: "blogPost", limit: 3 }).then((response: any) => response.items);
  const resultats = await client.getEntries({ content_type: "resultats", order: "fields.dateMatch" }).then((response: any) => response.items);
  const matchsAVenir = await client.getEntries({ content_type: "prochainMatchs", order: "fields.dateMatch" }).then((response: any) => response.items);

  return {
    props: {
      articles,
      resultats,
      matchsAVenir,
      updatedAt: Date.now(),
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 10, // In seconds
  };
}

type HomeProps = {
  articles: Array<any>;
  resultats: Array<any>;
  matchsAVenir: Array<any>;
  updatedAt: number;
};

const Home: NextPage<HomeProps> = ({ articles, resultats, matchsAVenir, updatedAt }) => {
  console.info(`Dernière mise à jour : ${new Date(updatedAt).toLocaleTimeString()}`);

  // const { t } = useTranslation("home");
  return (
    <motion.div variants={parent} animate="animate" initial="initial" exit={{ opacity: 0 }}>
      <SEO />

      <motion.section variants={contentSlideUp} transition={transition} id="main-hero">
        <Hero />
      </motion.section>

      <motion.section variants={contentSlideUp} transition={transition} id="news" className="bg-darkAccent shadow-inner">
        <AccueilNews articles={articles} />
      </motion.section>

      <motion.section variants={contentSlideUp} transition={transition} id="ambitions-pro" className="container-margin container-padding container">
        <AmbitionsPro />
      </motion.section>

      <motion.section variants={contentSlideUp} transition={transition} id="resultats-et-futurs-matchs" className="container-margin bg-darkAccent text-whiteAccent shadow-inner">
        <span className="container-padding container flex flex-col py-28 lg:py-36">
          <h2 className="mb-14">Activités recentes</h2>
          <span className="flex flex-col gap-16">
            <span>
              <h3 className="mb-4 text-xl font-semibold uppercase text-redAccent lg:text-2xl">Derniers resultats</h3>
              <Resultats resultats={resultats.reverse()} />
            </span>
            <span>
              <h3 className="mb-4 text-xl font-semibold uppercase text-redAccent lg:text-2xl">Prochains matchs</h3>
              <MatchsAVenir matchAVenir={matchsAVenir} />
            </span>
          </span>
        </span>
      </motion.section>

      <motion.section variants={contentSlideUp} transition={transition} id="HOF-accueil" className="container-margin text-whiteAccent">
        <HOF />
      </motion.section>
    </motion.div>
  );
};

export default Home;
